import { PlanType } from '@showbie-socrative/socrative-utils';

import { FeaturePermission } from './types';

export const proPermission: FeaturePermission = {
  addRoom: true,
  addRoster: true,
  createLibrary: true,
  createWorkspaceFolder: true,
  customizeExportResults: true,
  deleteWorkspaceFolder: true,
  embedMedia: true,
  limitOneAttempt: true,
  makeFolders: true,
  manuallyGrade: true,
  mergeQuizzes: true,
  moveWorkspaceFolder: true,
  pauseActivity: true,
  purgeWorkspaceFolder: true,
  renameWorkspaceFolder: true,
  restoreTrash: true,
  restoreWorkspaceFolder: true,
  shareResults: true,
  shareRoom: true,
  showAdvancedQuizEditor: true,
  timeSpaceRace: true,
  useSharedLibraryQuizzes: true,
  userPlan: PlanType.Pro,
};

export const starterPermission: FeaturePermission = {
  addRoom: true,
  addRoster: true,
  createLibrary: false,
  createWorkspaceFolder: false,
  customizeExportResults: true,
  deleteWorkspaceFolder: false,
  embedMedia: false,
  limitOneAttempt: true,
  makeFolders: true,
  manuallyGrade: true,
  mergeQuizzes: true,
  moveWorkspaceFolder: false,
  pauseActivity: true,
  purgeWorkspaceFolder: false,
  renameWorkspaceFolder: false,
  restoreTrash: true,
  restoreWorkspaceFolder: false,
  shareResults: true,
  shareRoom: true,
  showAdvancedQuizEditor: true,
  timeSpaceRace: true,
  useSharedLibraryQuizzes: false,
  userPlan: PlanType.Starter,
};

export const essentialsPermission: FeaturePermission = {
  addRoom: true,
  addRoster: true,
  createLibrary: false,
  createWorkspaceFolder: false,
  customizeExportResults: true,
  deleteWorkspaceFolder: false,
  embedMedia: false,
  limitOneAttempt: true,
  makeFolders: true,
  manuallyGrade: true,
  mergeQuizzes: true,
  moveWorkspaceFolder: false,
  pauseActivity: true,
  purgeWorkspaceFolder: false,
  renameWorkspaceFolder: false,
  restoreTrash: true,
  restoreWorkspaceFolder: false,
  shareResults: true,
  shareRoom: true,
  showAdvancedQuizEditor: true,
  timeSpaceRace: true,
  useSharedLibraryQuizzes: false,
  userPlan: PlanType.Essentials,
};

export const legacyFreePermission: FeaturePermission = {
  addRoom: false,
  addRoster: false,
  createLibrary: false,
  createWorkspaceFolder: false,
  customizeExportResults: false,
  deleteWorkspaceFolder: false,
  embedMedia: false,
  limitOneAttempt: false,
  makeFolders: false,
  manuallyGrade: false,
  mergeQuizzes: false,
  moveWorkspaceFolder: false,
  pauseActivity: false,
  purgeWorkspaceFolder: false,
  renameWorkspaceFolder: false,
  restoreTrash: true,
  restoreWorkspaceFolder: false,
  shareResults: false,
  shareRoom: false,
  showAdvancedQuizEditor: false,
  timeSpaceRace: false,
  useSharedLibraryQuizzes: false,
  userPlan: PlanType.FreeLegacy,
};

// This is the new experience free
export const freePermission: FeaturePermission = {
  addRoom: false,
  addRoster: false,
  createLibrary: false,
  createWorkspaceFolder: false,
  customizeExportResults: false,
  deleteWorkspaceFolder: false,
  embedMedia: false,
  limitOneAttempt: false,
  makeFolders: false,
  manuallyGrade: false,
  mergeQuizzes: true,
  moveWorkspaceFolder: false,
  pauseActivity: false,
  purgeWorkspaceFolder: false,
  renameWorkspaceFolder: false,
  restoreTrash: false,
  restoreWorkspaceFolder: false,
  shareResults: false,
  shareRoom: true,
  showAdvancedQuizEditor: true,
  timeSpaceRace: true,
  useSharedLibraryQuizzes: false,
  userPlan: PlanType.Free,
};
